<template>
  <el-container>
    <el-aside width="300px"></el-aside>
    <el-main>
      <el-card class="box">
        <template v-slot:header>
          <div class="card-header">
              <span style="font-weight: bold;color: #F1F7E7;font-size: 20px;">
                <i class="icon iconfont icon-baiyoujiazhitubiao-46" style="font-weight: bold;font-size: 20px;margin-right: 5px;"></i>Identification of the Closest-gene</span>
          </div>
        </template>
        <el-col :span="12">
          <el-row>
            <el-form>
              <el-form-item label="Species" style="font-weight: bold;margin-top: 10px;">
                <el-select v-model="species" placeholder="Please select species" style="width: 331.55px;">
                  <el-option v-for="option in speciesOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-radio-group v-model="selectedOption">
                  <el-radio label="Regions" style="font-weight: bold;">Regions</el-radio>
                </el-radio-group>
                <el-input type="textarea" :rows="2" :autosize="{ minRows: 2, maxRows: 4}" placeholder="eg: chr6:52247800-52247810" v-model="textarea" style="margin-top: 10px;"></el-input>
                <el-button size="medium" type="primary" style="background-color: #2C3E50;border: 1px solid #2C3E50;margin-top: 10px;" @click="fillExampleRegions">example of regions</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm" :loading="loading" style="background-color: #2C3E50;border: 1px solid #2C3E50;margin-top: 10px;" :disabled="!isIdentifiable" size="medium">
                  identify region text
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-radio-group v-model="selectedOption">
                  <el-radio label="Region file" style="font-weight: bold;">Region file</el-radio>
                </el-radio-group>
                <el-input v-model="bedFileName" placeholder="Please select the bed file" readonly></el-input>
                <el-upload
                  class="upload-btn"
                  action="http://183.175.59.4/devenhancer/closest_gene/"
                  :show-file-list="false"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                >
                  <template v-slot:trigger>
                    <el-button size="medium" type="primary" style="background-color: #2C3E50;border: 1px solid #2C3E50;margin-top: 10px;">select file</el-button>
                  </template>
                  <a href="@/../static/download/ESC_20.bed" download="">
                    <el-button size="medium" type="primary" style="background-color: #2C3E50;border: 1px solid #2C3E50;margin-top: 10px;">example of upload file</el-button>
                  </a>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitBedFile" :loading="loading" style="background-color: #2C3E50;border: 1px solid #2C3E50;margin-top: 10px;" size="medium">
                  identify region file
                </el-button>
              </el-form-item>
            </el-form>
          </el-row>
        </el-col>
        <el-col :span="12" class="col2">
          <h3 style="color: red">Function:</h3>
          <p style="font-size: large;">This function can identify the <span style="color:red">closest gene</span> to a given region.</p>
          <h3 style="color: red">Usage:</h3>
          <p style="font-size: large;">
            First, select the <span style="color: red">"Species"</span>. If you click on <span style="color: red">"Regions"</span>, you can enter the content in the input box. If you click on
            <span style="color: red"> "Region file"</span>, you can choose to upload a file. Finally, click on
            <span style="color:red">"identify"</span>.You can click on "example of upload file" to show example files.
          </p>
        </el-col>
    </el-card>
    </el-main>
    <el-aside width="300px"></el-aside>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      bedData: null,
      bedFileName: '',
      selectedOption: 'Regions', // 初始化选中的单选框
      textarea: '',
      exampleRegions: '',
      species: '',
      speciesOptions: [
        { label: 'human', value: 'human' },
        { label: 'mouse', value: 'mouse' },
      ],
      loading: false, // 添加 loading 状态
    };
  },
  computed: {
    isIdentifiable() {
      return this.species && ((this.selectedOption === 'Regions' && this.textarea) || (this.selectedOption === 'Region file' && this.bedFileName));
    },
  },
  mounted() {
    this.textarea = this.$route.params.textarea;
  },
  methods: {
    beforeUpload(file) {
      // 判断上传的文件是否为 Bed 格式
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType !== 'bed') {
        this.$message.error('Only files in .bed format can be uploaded');
        return false;
      }
      // 显示上传的文件名
      this.bedFileName = file.name;
      this.bedData = file;
      return false;
    },
    handleUploadSuccess(response) {
      // 处理上传成功后的响应数据
      console.log(response);
    },
    async submitForm() {
      // 在这里添加 loading
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('species', this.species);
        formData.append('selected_option', this.selectedOption);
        formData.append('textarea', this.textarea);

        const response = await this.$axios.post('http://183.175.59.4/devenhancer/closest_gene/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        this.$router.push({ name: 'Closestgenelist', params: { res: response.data, textarea: this.textarea } });
      } catch (error) {
        console.error(error);
      } finally {
        // 无论请求成功还是失败，都将 loading 设置为 false
        this.loading = false;
      }
    },
    submitBedFile() {
      // 类似地，在这里添加 loading
      this.loading = true;
      const formData = new FormData();
      formData.append('species', this.species); // 添加物种参数到表单数据
      formData.append('selected_option', this.selectedOption); // 添加选择的单选框值到表单数据
      formData.append('bed_file', this.bedData); // 添加 bed 文件到表单数据
      this.$axios.post('http://183.175.59.4/devenhancer/closest_gene_bed/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          this.$router.push({ name: 'Closestgenebedlist', params: { res: response.data } });
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          // 无论请求成功还是失败，都将 loading 设置为 false
          this.loading = false;
        });
    },
    fillExampleRegions() {
      this.exampleRegions = "chrX:52247800-52247810;\nchr20:50110400-50110420;\nchr9:133588400-133588450;\nchr8:128748100-128748170";
      this.textarea = this.exampleRegions;
    },
  },
};
</script>

<style scoped>
.box{
  margin-top: 60px;
}
.card-header {
  background-color: #2C3E50;
}
.box /deep/ .el-card__header {
  background-color: #2C3E50;/* 使用深度选择器 */
}
.col2{
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/analysis/Closestgene.vue